import { IpadToTvMultiScreenEvent, TvToIpadMultiScreenEvent } from 'events/multiScreenEvent';
import { SendPlayerEvent } from 'shared-types/player-event';

export const sendMultiScreenEventToTv: SendPlayerEvent = (eventType, data, timestamp) => {
  document.dispatchEvent(new IpadToTvMultiScreenEvent(eventType, data, timestamp));
};

export const sendMultiScreenEventToIpad: SendPlayerEvent = (eventType, data, timestamp) => {
  document.dispatchEvent(new TvToIpadMultiScreenEvent(eventType, data, timestamp));
};
